import { getStorage, setStorage } from 'utils/storage';

export const MAINTENANCE_BYPASS_STORAGE_KEY = 'maintenance_bypass_key';
export const MAINTENANCE_BYPASS_QUERY_PARAM = 'ops';

// Ops door through the maintenance page (JS-9654): opening /?ops=<key> once persists the key,
// so every later visit in that browser renders the full app while everyone else keeps seeing
// the maintenance page. The key ships in the bundle — obscurity, not security, exactly like
// the maintenance gate itself (it hides UI; the API protects itself). No key configured means
// no bypass exists at all, and a browser that refuses storage falls back to the maintenance page.
export const isMaintenanceBypassed = (bypassKey: string | undefined): boolean => {
  if (!bypassKey) {
    return false;
  }

  try {
    const fromUrl = new URLSearchParams(window.location.search).get(MAINTENANCE_BYPASS_QUERY_PARAM);

    if (fromUrl === bypassKey) {
      // Explicit expiry: the cookie-first storage path would otherwise write a session
      // cookie that dies with the browser, breaking the "every later visit" contract.
      // First-party JS is the only reader, so Strict beats the manager's None default.
      setStorage(MAINTENANCE_BYPASS_STORAGE_KEY, fromUrl, { sameSite: 'Strict', expires: 30 });
      return true;
    }

    return getStorage(MAINTENANCE_BYPASS_STORAGE_KEY) === bypassKey;
  } catch {
    return false;
  }
};
